// extracted by mini-css-extract-plugin
export var circle = "_f7-1";
export var exitConfirmationModal = "_f7-5";
export var iframe = "_f7-0";
export var offline = "_f7-3";
export var online = "_f7-2";
export var workstationSelectError = "_f7-4";